// toast.js — wrapper tipis di atas antd `message` untuk kode BARU.
//
// Tidak menggantikan pemanggilan message.* yang sudah ada di codebase -
// murni standar untuk pekerjaan baru ke depan, supaya key/duration selalu
// konsisten tanpa perlu diketik ulang tiap kali (lihat DESIGN_GUIDE.md).

import { message } from 'antd';

const DEFAULT_DURATION = 2;
const KEY = 'toast';

export const toastSuccess = (content, duration = DEFAULT_DURATION) =>
  message.success({ content, duration, key: KEY });

export const toastError = (content, duration = DEFAULT_DURATION) =>
  message.error({ content, duration, key: KEY });

export const toastWarning = (content, duration = DEFAULT_DURATION) =>
  message.warning({ content, duration, key: KEY });

export const toastInfo = (content, duration = DEFAULT_DURATION) =>
  message.info({ content, duration, key: KEY });

export const toastLoading = (content) =>
  message.loading({ content, duration: 0, key: KEY });

// Untuk pesan penting (auth/sesi) yang perlu tampil lebih lama - mengikuti
// pola yang sudah dipakai di AdminLayout.jsx/AuthLayout.jsx (6-10 detik).
export const toastErrorLong = (content, duration = 8) =>
  message.error({ content, duration, key: KEY });
